import { format as m } from "date-fns";
const E = (e, a) => m(e, "EEEEE", { locale: a == null ? void 0 : a.locale });
export {
  E as formatWeekdayName
};
